import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  NavigationItem,
  BadgeContainer,
  TabsContainer,
  BadgeText,
  BannerContainer,
  TabsWrapper,
} from "./TabsComponent.styles";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  clearExploreCollections,
  selectCategories,
  setSelectedExploreCollectionFilter,
  setSelectedExploreCollectionKeyword,
  setSelectedExploreCollectionSearch,
} from "../../../store/slices/model/slice";
import { useMediaQuery } from "react-responsive";
import { selectUser } from "../../../store/slices/user/slice";
import { selectLoggedIn } from "../../../store/slices/auth/slice";
import {
  resetCollectionTabAnimation,
  selectCollectionTabAnimating,
} from "../../../store/slices/common/slice";

const TABS = [
  { name: "Explore", path: "/" },
  { name: "Collection", path: "/collection" },
  { name: "Train", path: "/train", badge: true },
  { name: "Games", path: "/games" },
];

const TabsComponent = ({ hidden, setSearchValue, inline = false }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isExplorePage = location.pathname === "/";
  const { data: categories } = useSelector(selectCategories);
  const navigate = useNavigate();
  const alreadyGeneratedVideo = localStorage.getItem("alreadyGeneratedVideo");

  const user = useSelector(selectUser);
  const loggedIn = useSelector(selectLoggedIn);

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const isCollectionAnimating = useSelector(selectCollectionTabAnimating);

  useEffect(() => {
    if (isCollectionAnimating) {
      const timer = setTimeout(() => {
        dispatch(resetCollectionTabAnimation());
      }, 600);

      return () => clearTimeout(timer);
    }
  }, [isCollectionAnimating, dispatch]);

  return (
    <TabsContainer $hidden={hidden} $inline={inline}>
      {!inline && !alreadyGeneratedVideo && (
        <BannerContainer $isMobile={isMobile}>
          #1 Adult Video Generator
        </BannerContainer>
      )}
      <TabsWrapper>
        {TABS.map((tab) => {
          return (
            <NavigationItem
              key={tab.path}
              $isAnimating={tab.path === "/collection" && isCollectionAnimating}
            >
              <NavLink
                style={{ display: "flex", gap: "4px" }}
                to={tab.path}
                onClick={() => {
                  if (tab.path === "/" && isExplorePage) {
                    dispatch(clearExploreCollections());

                    if (setSearchValue) {
                      setSearchValue("");
                    }
                    dispatch(setSelectedExploreCollectionSearch(""));
                    dispatch(setSelectedExploreCollectionKeyword(null));
                    dispatch(
                      setSelectedExploreCollectionFilter(categories[0]._id),
                    );
                  }

                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant",
                  });
                }}
              >
                <p>{tab.name}</p>
              </NavLink>
              {(!!user || loggedIn === false) &&
                tab.badge &&
                !user?.hasTrainedModel && (
                  <BadgeContainer
                    onClick={() => {
                      navigate(tab.path);
                    }}
                  >
                    <BadgeText $bold>300 Credits!</BadgeText>
                    <BadgeText>For 1st Training</BadgeText>
                  </BadgeContainer>
                )}
            </NavigationItem>
          );
        })}
      </TabsWrapper>
    </TabsContainer>
  );
};

export default TabsComponent;
